import { render, staticRenderFns } from "./MakeUpAGroup.vue?vue&type=template&id=6bfe3832&scoped=true&"
import script from "./MakeUpAGroup.vue?vue&type=script&lang=js&"
export * from "./MakeUpAGroup.vue?vue&type=script&lang=js&"
import style0 from "./MakeUpAGroup.vue?vue&type=style&index=0&id=6bfe3832&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe3832",
  null
  
)

export default component.exports